/* import __COLOCATED_TEMPLATE__ from './actions-container.hbs'; */
/**
`dialog-header/actions-container` is mostly just a dumb block that can be
yielded out by parent components to allow consuming contexts to customize the
actions that appear on either side of the header title.

### Parameters
@param {String} [context] Determines the parent context in which this header is shown, which applies appropriate class name bindings.
@param {Boolean} hasButtons - Optional flag to indicate this container has `.button` elements with it. Adds a class that can be used for special button-related styling.
**/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { CONTEXT } from '../../utils/dialog-actions';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['dialog__header__actions-container'],
  classNameBindings: ['contextClass', 'hasButtons:dialog__header__actions-container--with-buttons'],
  contextClass: computed('context', 'hasButtons', function () {
    switch (this.get('context')) {
      case CONTEXT.SHEET:
        return this.get('hasButtons') ? 'dialog--sheet__header__actions-container dialog--sheet__header__actions-container--with-buttons' : 'dialog--sheet__header__actions-container';
      default:
        return '';
    }
  })
});